module.exports = __webpack_public_path__ + "img/calendar.f7dc82b0.svg";